import React, {useState} from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {bannerdata} from "../../data";
import { Link } from "react-router-dom";

export const HomeBanner = () => {
    const [banner] = useState(bannerdata);
    return (
        <div className="main_herosection">
            <Carousel emulateTouch={true} infiniteLoop={true} interval={8000} stopOnHover={true} autoPlay={true}>
                {banner.map((curElm) => {
                    return (
                        <div key={curElm.id}><Link to="#"><img src={curElm.image} alt={curElm.altdata} /></Link></div>
                    );
                })}
            </Carousel>
        </div>
    )
}